import type { PaletteOptions } from '@mui/material/styles';

/**
 * Ham marka + nötr renk paleti — `theme.ts`'in tek renk kaynağı. Işık ve karanlık
 * şema burada yan yana tanımlı ki kimlik (kraliyet mavisi + mercan vurgu) iki modda
 * da tutarlı kalsın. Karanlık şema `primary`/`secondary` tonlarını koyu yüzeyde
 * WCAG AA kontrastına taşıyacak şekilde açar; mercan yalnız vurgu rengi olarak durur.
 *
 * Faz 1: ışık şema değerleri bugünkü `theme.ts` ile birebir. Estetik rafine (yüzey
 * tonları, `surfaceSunken`, gölge token'ları) Faz 2'de.
 */

export const brand = {
  blue: '#2954E8',
  blueDark: '#173AAE',
  blueLight: '#6E8CF2',
  coral: '#FF7A45',
  coralDark: '#E85D26',
} as const;

/** Login marka paneli + dashboard hero — tek onaylı gradient (Faz 2). */
export const brandGradient =
  `linear-gradient(135deg, ${brand.blueDark} 0%, ${brand.blue} 55%, ${brand.blueLight} 130%)`;

/** Işık şema — kurumsal panel; sıcak-nötr zemin, saf beyaz kağıt. */
export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: brand.blue,
    dark: brand.blueDark,
    light: brand.blueLight,
    contrastText: '#ffffff',
  },
  secondary: {
    main: brand.coral,
    dark: brand.coralDark,
    contrastText: '#ffffff',
  },
  background: { default: '#F4F6FB', paper: '#ffffff' },
  divider: '#E4E9F5',
  text: { primary: '#16233D', secondary: '#5B6B85' },
  success: { main: '#1FA971' },
  warning: { main: '#F0A93A' },
  error: { main: '#E4483B' },
  info: { main: '#2E90D6' },
  /** Tablo başlıkları, inset alanlar — mavi tint yerine nötr çökük yüzey. */
  surfaceSunken: '#EEF1F8',
};

/** Karanlık şema — iki adımlı elevation, kimlik mavisi açılmış hâlde. */
export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#7C99F7',
    dark: '#5E82F5',
    light: '#A6B8FA',
    contrastText: '#0E1526',
  },
  secondary: {
    main: '#FF9160',
    dark: brand.coral,
    contrastText: '#0E1526',
  },
  background: { default: '#0E1526', paper: '#161F33' },
  divider: '#26324B',
  text: { primary: '#E8ECF5', secondary: '#9AA7BF' },
  success: { main: '#3FBF8A' },
  warning: { main: '#F0B457' },
  error: { main: '#F0655A' },
  info: { main: '#54A8E0' },
  /** Karanlıkta çökük değil, hafif yükseltilmiş yüzey (kağıttan bir ton açık). */
  surfaceSunken: '#1E293F',
};
